

    <div class="container-fluid">
        <div class="card  card-finance">
            <div class="finance-client-header">
                <div>
                    <div class="card-header card-header-icon card-header-warning">
                    </div>
                    <h3 class="card-title-finance">Stranke</h3>
                </div>
                
                <div style="width: 100%;">
                    <div class="button-wrapper">
                        <div *ngIf="!showEmailSettingsReport">
                            <button type="button" class="btn custom-button" [routerLink]="['/finance']"
                            routerLinkActive="router-link-active" (click)="onCloseClick()" >
                            <mat-icon>close</mat-icon>
                            Odustani
                            </button>
                        
                            <button  type="submit" class=" btn  custom-button"
                            (click)="onSubmit()">
                            <mat-icon>save</mat-icon>
                            Sačuvaj</button>
            
                            <button  type="submit" class="btn   custom-button" (click)="onSubmitNew()">
                                <mat-icon>save</mat-icon>
                            Sačuvaj i nov</button>
                        </div>

                        <div *ngIf="showEmailSettingsReport">
                            <button class=" btn custom-button">Sačuvaj email podešavanja</button>
                            <button class=" btn custom-button" (click)="back()">Nazad</button>
                        </div>

                        <div style="margin-right: 20px;">
                            <button class="btn custom-button" (click)="showEmailSettings()">
                                <mat-icon>email</mat-icon>
                            </button>
                        </div>

                    </div>
                </div>
            </div>

            <form [formGroup]="addFinanceForm" (ngSubmit)="onSubmitNew()" *ngIf="!showEmailSettingsReport">
                <div class="form-group client-form-wrapper">
                    <div class="finance-client-info">
                        <h3 class="card-title-finance">Osnovni podaci</h3>
                        <div  class="form-item" >
                            <label for="username">Naziv*:</label>
                        
                            <input type="text" id="username" formControlName="username"[ngClass]="{'error-input': addFinanceForm.get('username').invalid && addFinanceForm.get('username').touched}">
                            <div>
                                <mat-error  class="select-mat-error" *ngIf="addFinanceForm.get('username').hasError('required') && addFinanceForm.get('username').touched">
                                Naziv je obavezno polje.
                                </mat-error>
                            </div>
                        </div>
                        <div  class="form-item">
                            <label for="address">Adresa*:</label>
                            <input  type="text" id="address" formControlName="address" [ngClass]="{'error-input': addFinanceForm.get('address').invalid && addFinanceForm.get('address').touched}">
                            <div>
                                <mat-error  class="select-mat-error" *ngIf="addFinanceForm.get('address').hasError('required') && addFinanceForm.get('address').touched">
                                Adresa je obavezno polje.
                                </mat-error>
                            </div>
                        </div>
                        <div  class="form-item">
                            <label for="country">Država*:</label>
                            <input type="text" id="country" formControlName="country" [ngClass]="{'error-input': addFinanceForm.get('country').invalid && addFinanceForm.get('country').touched}">
                            <div>
                                <mat-error  class="select-mat-error" *ngIf="addFinanceForm.get('country').hasError('required') && addFinanceForm.get('country').touched">
                                Drzava je obavezno polje.
                                </mat-error>
                            </div>
                        </div>
                        <div  class="form-item">
                            <label for="post">Pošta*:</label>
                            <input type="text" id="post" formControlName="post" [ngClass]="{'error-input': addFinanceForm.get('post').invalid && addFinanceForm.get('post').touched}">
                            <div>
                                <mat-error  class="select-mat-error" *ngIf="addFinanceForm.get('post').hasError('required') && addFinanceForm.get('post').touched">
                                    Pošta je obavezno polje.
                                </mat-error>
                            </div>
                        </div>
                        <div  class="form-item">
                            <label for="address">PIB*:</label>
                            <input  type="text" id="pib" formControlName="pib" [ngClass]="{'error-input': addFinanceForm.get('pib').invalid && addFinanceForm.get('pib').touched}">
                            <div>
                                <mat-error  class="select-mat-error" *ngIf="addFinanceForm.get('pib').hasError('required') && addFinanceForm.get('pib').touched">
                                PIB je obavezno polje.
                                </mat-error>
                            </div>
                        </div>
                        <div  class="form-item">
                            <label for="address">Matični broj*:</label>
                            <input  type="text" id="indetificationNumber" formControlName="indetificationNumber" [ngClass]="{'error-input': addFinanceForm.get('indetificationNumber').invalid && addFinanceForm.get('indetificationNumber').touched}">
                            <div>
                                <mat-error  class="select-mat-error" *ngIf="addFinanceForm.get('indetificationNumber').hasError('required') && addFinanceForm.get('indetificationNumber').touched">
                                Matični broj je obavezno polje.
                                </mat-error>
                            </div>
                        </div>
                        <div  class="form-item">
                            <label for="password">Grad:</label>
                            <input type="text" id="password" formControlName="password">
                        </div>
                        <div  class="form-item">
                            <label  for="customer">Kupac:</label>
                            <input type="checkbox"  id="customer1" formControlName="customer1"   (change)="onCustomer1Change($event.target.checked)" >
                            <label  for="customer1">Kupac</label>
                            
                            <input type="checkbox" id="customer2" formControlName="customer2" (change)="onCustomer2Change($event.target.checked)" >
                            <label for="customer2">Dobavljač</label>
                        </div>
                        <div  class="form-item">
                            <label  for="startState">Početno stanje:</label>
                            <input  type="text" id="startState" formControlName="startState">
                        </div>
                    </div>

                    <div class="finance-contact-info">
                        <h3 class="card-title-finance">Kontakti</h3>
                        <div  class="form-item">
                            <label for="firstName">Ime i prezime:</label>
                            <input type="text" id="firstName" formControlName="firstName">
                        </div>
                        <div class="form-item">
                            <label for="email">E-pošta:</label>
                            <input type="email" id="email" formControlName="email">
                        </div>
                        <div  class="form-item">
                            <label for="name">Naziv:  </label>
                            <input  type="text" id="name" formControlName="name">
                        </div>
                        <div class="form-item">
                            <label for="phone">Telefon:</label>
                            <input type="phone" id="phone" formControlName="phone">
                        </div>
                        <div  class="form-item">
                            <label for="note">Napomena:  </label>
                            <input class="inputleft" type="note" id="note" formControlName="note">
                        </div>
                        <div class="form-item">
                            <label for="fax">Fax:</label>
                            <input type="fax" id="fax" formControlName="fax">
                        </div>
                        <div  class="form-item">
                            <label for="mobilePhone">Mobilni telefon:  </label>
                            <input type="text" id="mobilePhone" formControlName="mobilePhone">
                        </div>
                        <div  class="form-item">
                            <label  for="customer">Slanje na mail:</label>
                            <input type="checkbox"  id="sendEmail" formControlName="sendEmail"   (change)="onSendEmialChange($event.target.checked)" >
                        </div>
                    </div>
                </div>
            </form>

            <div *ngIf="showEmailSettingsReport" class="card-body">
                <section [formGroup]="emailNotification">
                    <mat-checkbox formControlName="dayBeforePayment" style="margin: 0 10px;">Dan pre dospeća</mat-checkbox>
                    <mat-checkbox formControlName="datAfterPayment" style="margin: 0 10px;">Dan posle dospeća</mat-checkbox>
                    <mat-checkbox formControlName="warningBeforeSuspension" style="margin: 0 10px;">Opomena pred isključenje</mat-checkbox>
                </section>
            </div>
        </div>
    </div>

  
  